<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="栏目"
      edit-title
      id-key="ColumnId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="栏目名称" prop="ColumnName" label-width="120px">
              <el-input
                v-model="data.ColumnName"
                placeholder="填写栏目名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="栏目名称英文" prop="ColumnNameEn" label-width="120px">
              <el-input
                v-model="data.ColumnNameEn"
                placeholder="填写栏目名称英文"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="导航栏" prop="NavType" label-width="120px">
              <el-select v-model="data.NavType" placeholder="填写所属模块">
                <el-option :value="0" label="不显示">不显示</el-option>
                <el-option :value="1" label="显示顶部">显示顶部</el-option>
                <!-- <el-option :value="2" label="显示底部">显示底部</el-option> -->
                <!-- <el-option :value="3" label="显示顶部和底部">显示顶部和底部</el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="所属模块" prop="Module" label-width="120px">
              <el-radio-group v-model="data.Module">
                <el-radio :label="0">文章</el-radio>
                <el-radio :label="1">简介</el-radio>
                <!-- <el-radio :label="2">产品</el-radio>
                <el-radio :label="3">图片</el-radio>
                <el-radio :label="4">留言</el-radio> -->
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="外部链接" prop="ExternalLink" label-width="120px">
              <el-input
                v-model="data.ExternalLink"
                placeholder="填写外部链接"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上级" prop="Pid" label-width="120px">
              <select-input
                placeholder="选择上级"
                :label="data.Pname"
                v-model="data.Pid"
                @click="openColumnDialog"
                :isAll="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="Banner" prop="Banner" label-width="120px">
              <single-pic-upload
                v-model="data.Banner"
                type="Banner"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="SEO标题" prop="SeoTitle" label-width="120px">
              <el-input
                v-model="data.SeoTitle"
                placeholder="填写SEO标题"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="SEO关键词" prop="SeoKeyword" label-width="120px">
              <el-input
                v-model="data.SeoKeyword"
                placeholder="填写SEO关键词"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="SEO描述" prop="SeoDescription" label-width="120px">
              <el-input
                v-model="data.SeoDescription"
                placeholder="填写SEO描述"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="静态名称" prop="StaticName" label-width="120px">
              <el-input
                v-model="data.StaticName"
                placeholder="填写静态名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="24">
            <el-form-item label="首页序号" prop="IndexSort" label-width="120px">
              <el-input-number :min="0" v-model="data.IndexSort"></el-input-number>
              <span class="t-tips">值越小排得越前 0不显示在首页</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="首页所占列数" prop="IndexCol" label-width="120px">
              <el-input-number :min="1" :max="12" v-model="data.IndexCol"></el-input-number>
              <span class="t-tips">一行12列</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="序号" prop="Sort" label-width="120px">
              <el-input-number :min="0" v-model="data.Sort"></el-input-number>
              <span class="t-tips">值越小排得越前</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <column-dialog
      ref="columnDialog"
      title="选择上级菜单"
      @select="setParent"
    ></column-dialog>
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import editDialogMixin from "@/mixins/editDialog";
import columnDialog from "./listDialog";
import api from "@/api/website/column/column";
import selectInput from "@/components/common/selectInput";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    columnDialog,
    selectInput,
    singlePicUpload,
  },
  data() {
    return {
      data: {
        ColumnId: 0, 
        ColumnName: "", 
        ColumnNameEn: "", 
        NavType: 0, 
        Module: 0, 
        ExternalLink: "", 
        Banner: "", 
        SeoTitle: "", 
        SeoKeyword: "", 
        SeoDescription: "", 
        StaticName: "", 
        Pid: 0, 
        Pname: "",
        Lv: 0, 
        IndexCol: 1,
        Sort: 0, 
        IndexSort: 0,   
      },
      api,
       rules: {
        ColumnName: [{ required: true, message: "栏目中文不能为空" }],
        // ColumnNameEn: [{ required: true, message: "栏目英文不能为空" }],
        NavType: [{ required: true, message: "导航栏显示不能为空" }],
        Module: [{ required: true, message: "所属模块不能为空" }],
        IndexSort: [{ required: true, message: "首页序号不能为空" }],
        IndexCol: [{ required: true, message: "首页所占列数不能为空" }],
        Sort: [{ required: true, message: "序号不能为空" }],
        Lv: [{ required: true, message: "级数不能为空" }],
      },
      uploadUrl:"/api/column/uploadPicture"
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      this.data.Pid = data.Pid;
      this.data.Pname = data.PName;
    },
    openColumnDialog() {
      this.$refs.columnDialog.open().then((that) => {
        that.$refs.list.getData();
      });
    },
    setParent(parent) {
      if (this.data.ColumnId == parent.ColumnId) {
        this.$message.error("不可以选择自己为上级");
        return;
      }
      this.data.Pid = parent.ColumnId;
      this.data.Pname = parent.ColumnName;

    },
    setSort(sort) {
      this.data.Sort = sort;
    },
  },
};
</script>